<template>
  <div class="pane-content">
    <div class="panel dash-carousel">
      <div class="panel-heading">
        <h3 class="heading -medium">Featured</h3>
      </div>
      <div class="panel-body">
        <carousel
          :per-page="1"
          :navigation-enabled="false"
          :navigation-click-target-size="5"
          pagination-color="#BDC3D0"
          pagination-active-color="#282B39"
          :pagination-padding="7"
          :pagination-size="6"
        >
          <slide v-for="slide in slides" :key="slide.title" class="dashboard-slide-container">
            <a class="dashboard-slide" :href="slide.url">
              <exclusive-badge :is-exclusive="!!slide.is_exclusive" />
              <img
                :data-src="`${cdn.siteAssetsPrefix}/${slide.img_dir}/640/640-${slide.image}`"
                :alt="slide.title"
                width="340"
                height="180"
                :data-srcset="`
                  ${cdn.siteAssetsPrefix}/${slide.img_dir}/${slide.image} 1920w,
                  ${cdn.siteAssetsPrefix}/${slide.img_dir}/1020/1020-${slide.image} 1020w,
                  ${cdn.siteAssetsPrefix}/${slide.img_dir}/800/800-${slide.image} 800w,
                  ${cdn.siteAssetsPrefix}/${slide.img_dir}/640/640-${slide.image} 640w,
                  ${cdn.siteAssetsPrefix}/${slide.img_dir}/320/320-${slide.image} 320w
                `"
                sizes="
                  (min-width: 1340px) 640px,
                  (min-width: 641px) and (max-width: 1339px) 50vw,
                  (max-width: 600px) 100vw
                "
                class="lazyload"
              />
              <div class="title">
                <div>
                  <div class="eyebrow caps medium">{{ slide.eyebrow }}</div>
                  <h5 class="heading -small no-margin">{{ slide.title }}</h5>
                </div>
              </div>
            </a>
          </slide>
        </carousel>
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import { defineComponent } from 'vue'
import type { PropType } from 'vue'
import { mapState } from 'pinia'
import { Carousel, Slide } from '@jambonn/vue-concise-carousel'

import ExclusiveBadge from '@/components/badges/exclusive-badge.vue'
import { useUserAuthStore } from '@/stores/user-auth'

export default defineComponent({
  name: 'DashboardCarousel',
  components: {
    Carousel,
    Slide,
    ExclusiveBadge,
  },
  props: {
    slides: {
      type: Array as PropType<any[]>,
      required: true,
    },
  },
  computed: {
    ...mapState(useUserAuthStore, ['cdn']),
  },
})
</script>
